import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./CourseDetail.scss";
import Close from "../../../assets/images/icons/close.svg";
import axios from "axios";
import { authenticatedVimeoEmbedUrl } from "../../Media/vimeoEmbed";

// Pure selection: accept only an existing permitted-list row with the requested decimal ID.
export function courseDetailVideoId(value) {
  if (typeof value === "number") return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
  return typeof value === "string" && /^[1-9][0-9]*$/.test(value) ? value : null;
}

export function selectCourseDetailVideo(rows, requestedId) {
  const id = courseDetailVideoId(requestedId);
  if (!id || !Array.isArray(rows)) return null;
  return rows.find((row) => row && courseDetailVideoId(row.video_id) === id) || null;
}
// End pure selection.

const CourseDetail = () => {
  const [data, setData] = useState({});
  const { option2 } = useParams();

  function removeImg() {
    var imgToRemove = document.querySelector(
      'img[src="images/cal-icon_g.png"]'
    );

    if (imgToRemove) {
      imgToRemove.parentNode.removeChild(imgToRemove);
    }
  }
  const courseDetails = async (context, isCurrent) => {
    const login_cookie = context.loginCookie;
    const login_user_id = context.loginUserId;
    const login_action_type = context.loginActionType;

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getCourseDetailsByCourseId&school_id=${context.schoolId}&level_id=${context.levelId}&course_id=${context.courseId}&user_id=${context.loginUserId}&from_app_new=1&status=1`
      )
      .then((resp) => {
        if (!isCurrent()) return;
        setData(resp.data);
        removeImg();
      });
  };

  const [videoData, setVideoData] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [videoOwner, setVideoOwner] = useState(null);
  const readVideoContext = () => ({
    loginUserId: localStorage.getItem("session_user_id"),
    loginCookie: localStorage.getItem("session_user_login_cookie"),
    loginActionType: localStorage.getItem("session_user_type"),
    schoolId: localStorage.getItem("session_school_id"),
    levelId: localStorage.getItem("session_user_level_id"),
    courseId: option2,
  });
  const ownsCurrentVideoList = videoOwner && JSON.stringify(videoOwner) === JSON.stringify(readVideoContext());

  const getVideoData = async (context, isCurrent) => {
    const formData = new FormData();
    formData.append("user_id", context.loginUserId);

    const login_cookie = context.loginCookie;
    const login_user_id = context.loginUserId;
    const login_action_type = context.loginActionType;
    const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getVideos&status=1`;

    await axios.post(api, formData).then((resp) => {
      if (!isCurrent()) return;
      setVideoOwner(context);
      setVideoData(Array.isArray(resp.data) ? resp.data : []);
      setCurrentVideo(null);
      removeImg();
    });
  };

  const searchAndShowVideo = (detail) => {
    setCurrentVideo(ownsCurrentVideoList ? selectCourseDetailVideo(videoData, detail) : null);
  };
  const selectedVideo = ownsCurrentVideoList && currentVideo && selectCourseDetailVideo(videoData, currentVideo.video_id);
  const currentVideoSrc = selectedVideo ? authenticatedVimeoEmbedUrl(
    selectedVideo.video_url,
    process.env.REACT_APP_API_BASE_URL,
    videoOwner
  ) : null;
  const currentVideoDate = typeof selectedVideo?.video_cretaed_date === "string"
    ? selectedVideo.video_cretaed_date : "";

  useEffect(() => {
    let cancelled = false;
    const context = readVideoContext();
    const isCurrent = () => !cancelled && JSON.stringify(context) === JSON.stringify(readVideoContext());
    setData({});
    setVideoData([]);
    setVideoOwner(null);
    setCurrentVideo(null);
    courseDetails(context, isCurrent).catch(() => { if (isCurrent()) setData({}); });
    getVideoData(context, isCurrent).catch(() => {
      if (!isCurrent()) return;
      setVideoData([]);
      setVideoOwner(null);
      setCurrentVideo(null);
    });
    removeImg();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option2]);
  return (
    <div className="apply_course_section">
      <div className="container-fluid">
        <div className="user_detail">
          <div className="apply_course_title">
            <h2>Course Detail</h2>
          </div>
        </div>
        <div className="video_list_modal">
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <Link
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <img className="img-fluid" src={Close} alt="" />
                  </Link>
                </div>
                <div className="modal-body">
                  <div className="date_time_title">
                    <div className="date_time">
                      <div className="date">
                        <p>{currentVideoDate.slice(0, 11)}</p>
                      </div>
                      <div className="time">
                        <p>{currentVideoDate.slice(11)}</p>
                      </div>
                    </div>
                    <div className="title_detail">
                      <h3>{selectedVideo?.video_title}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: selectedVideo?.video_description,
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="video_block">
                    {currentVideoSrc ? (
                      <iframe
                        title="Course video"
                        src={currentVideoSrc}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <p>NO VIDEO</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Object.values(data)?.map(
          (item, index) =>
            index === 0 && (
              <div key={index}>
                <div className="apply_course_inner">
                  <div className="apply_course_card row">
                    <div className="my_courses_card col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="apply_course_card_inner">
                        <div className="apply_course_card_title">
                          <h2>{item?.course_title}</h2>
                        </div>
                        <div className="apply_course_detail">
                          <ul className="apply_course_list">
                            <li className="apply_course_item">
                              <span>Description :</span>
                              <span>{item?.course_description}</span>
                            </li>
                            <li className="apply_course_item">
                              <span>Phase :</span>
                              <span>
                                {item?.course_level_number} ({item?.level_name})
                              </span>
                            </li>
                            <li className="apply_course_item">
                              <span>Starting Time :</span>
                              <span>{item.class_start_time}</span>
                            </li>
                            <li className="apply_course_item">
                              <span>Ending Time :</span>
                              <span>{item.class_end_time}</span>
                            </li>
                            <li className="apply_course_item">
                              <span>Room :</span>
                              <span>{item.course_room}</span>
                            </li>
                            <li className="apply_course_item">
                              <span>Teacher 1:</span>
                              <span>{item.teacher1}</span>
                            </li>
                            <li className="apply_course_item">
                              <span>Teacher 2:</span>
                              <span>{item.teacher2}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="apply_data_table">
                  {Object.values(item.course_goal_first_four)?.map(
                    (firstFourData, firstFourIndex) => (
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col" colSpan="3">
                                {
                                  Object.keys(item.course_goal_first_four)[
                                    firstFourIndex
                                  ]
                                }
                              </th>
                            </tr>
                          </thead>
                          <tbody className="table-group-divider">
                            {firstFourData?.map(
                              (innerTableData, innerTableIndex) => (
                                <>
                                  {innerTableData.video_id !== undefined ? (
                                    <tr
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModal"
                                      onClick={() => {
                                        searchAndShowVideo(
                                          innerTableData.video_id
                                        );
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: innerTableData.title,
                                      }}
                                      key={innerTableIndex}
                                    ></tr>
                                  ) : (
                                    <tr
                                      dangerouslySetInnerHTML={{
                                        __html: innerTableData.title,
                                      }}
                                      key={innerTableIndex}
                                    ></tr>
                                  )}
                                </>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    )
                  )}

                  {Object.values(item.course_goal_rest_after_four)?.map(
                    (firstFourData, firstFourIndex) => (
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col" colSpan="3">
                                {
                                  Object.keys(item.course_goal_first_four)[
                                    firstFourIndex
                                  ]
                                }
                              </th>
                            </tr>
                          </thead>
                          <tbody className="table-group-divider">
                            {Object.values(firstFourData)?.map(
                              (innerTableData, innerTableIndex) => (
                                <>
                                  {innerTableData.video_id !== undefined ? (
                                    <tr
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModal"
                                      onClick={() => {
                                        searchAndShowVideo(
                                          innerTableData.video_id
                                        );
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: innerTableData.title,
                                      }}
                                      key={innerTableIndex}
                                    ></tr>
                                  ) : (
                                    <tr
                                      dangerouslySetInnerHTML={{
                                        __html: innerTableData.title,
                                      }}
                                      key={innerTableIndex}
                                    ></tr>
                                  )}
                                </>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    )
                  )}
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default CourseDetail;
